import { PaymentMethods } from '@/constants/payment';
import {
  CreateAbandonmentPayload,
  InstallmentsData,
  PayData,
  Payment,
  PaymentPayload,
  ProductData
} from '@/types';
import { getCookieValue } from '@/utils/cookies';
import { addQueryParamsToEndpoint, getQueryParams } from '@/utils/url';
import { ClientJS } from 'clientjs';
import axios from 'axios';
import { getCheckoutField } from '@/utils/analytics';

export const generateCreditCardToken = async (card: {
  number: string;
  holderName: string;
  expMonth: string;
  expYear: string;
  cvv: string;
}) => {
  // eslint-disable-next-line
  // @ts-ignore
  NoxPay.setPublicKey(import.meta.env.VITE_HOPYPAY_PUBLIC_KEY);
  // eslint-disable-next-line
  // @ts-ignore
  return await NoxPay.encrypt(card);
};

export const getCheckoutData = async (
  id: string,
  affiliateShortId: string
): Promise<ProductData> => {
  const baseURL = import.meta.env.VITE_BASE_CHECKOUT_API_URL || import.meta.env.VITE_BASE_API_URL;
  const axiosInstance = axios.create({ baseURL: baseURL });
  const checkoutUrl = window.location.href;

  const endpoint = `/api/product/checkout/${id}/`;

  const currentUrl = window.location.href;

  const queryParams = getQueryParams(currentUrl);

  const ttclid = queryParams['ttclid'];
  const clickid = queryParams['clickid'];

  const ttp = getCookieValue('_ttp') || undefined;
  const fbp = getCookieValue('_fbp') || undefined;
  const fbc = getCookieValue('_fbc') || undefined;

  const email = getCheckoutField('email');
  const phone = getCheckoutField('phone');
  const name = getCheckoutField('name');
  const city = getCheckoutField('city');
  const state = getCheckoutField('state');
  const zipcode = getCheckoutField('zipcode');
  const country = getCheckoutField('country');

  const params = {
    affiliateShortId,
    checkoutUrl,
    ttclid,
    ttp,
    clickid,
    fbp,
    fbc,
    email,
    phone,
    name,
    city,
    state,
    zipcode,
    country,
  };

  const url = addQueryParamsToEndpoint(endpoint, params);

  return axiosInstance.get(url, { withCredentials: true }).then(({ data }) => ({
    ...data,
    // TODO: This was placed here because of the backend cache, which may not have been updated with the new paymentMethods format
    product: {
      ...data.product,
      paymentMethods:
        data?.product?.paymentMethods?.map((method: string | { type: string; name: string }) =>
          typeof method === 'object' ? method : PaymentMethods.find(({ type }) => type === method)
        ) || []
    }
  }));
};

export const startPayment = async (id: string, payload: PaymentPayload): Promise<PayData> =>
  axios.post(`/api/checkout/${id}/`, payload, { withCredentials: true }).then(({ data }) => data);

export const getPaymentStatus = async (id: string): Promise<Payment> =>
  axios.get(`/api/payment/status/${id}/`, { withCredentials: true }).then(({ data }) => data);

export const getInstallments = async (id: string, total: number): Promise<InstallmentsData[]> =>
  axios.get(`/api/checkout/installments/${id}/?total=${total}`).then(({ data }) => data);

export const createAbandonment = ({ offerId, ...payload }: CreateAbandonmentPayload) => {
  const url = `${import.meta.env.VITE_BASE_API_URL}api/checkout/${offerId}/abandonment/`;
  const blob = new Blob([JSON.stringify(payload)], { type: 'text/plain' });
  navigator.sendBeacon(url, blob);
};

export const generateFingerprint = async (): Promise<string> => {
  try {
    const client = new ClientJS();
    const fingerprint = client.getFingerprint();

  return String(fingerprint);
  } catch (error) {
    console.error('Error generating fingerprint', error);
    return '';
  }
};

export const validateCouponService = async ({
  code,
  offerId
}: {
  code: string;
  offerId?: string;
}) => axios.post('/api/coupons/validate/', { code, offerId }).then(({ data }) => data);

export const getAintifraudTokenId = async () =>
  axios
    .get(`${import.meta.env.VITE_MOCK_API_URL}/api/checkout/antifraud/ `)
    .then(({ data }) => data?.attempt_reference);
